import { Response } from 'miragejs';
import { StatusCodes as HTTP } from 'http-status-codes';

export default server => {
    server.get('/v1/users', (schema, { queryParams: { social_types: socialTypes } }) => {
        if (!socialTypes?.length) {
            const { models } = schema.profiles.all();

            return models;
        }

        const { models } = schema.profiles.where(profile => socialTypes.includes(String(profile.social_type)));

        return models;
    });

    server.delete('/v1/users/:id', (schema, { params: { id } }) => {
        const profile = schema.profiles.find(id);

        if (profile) {
            profile.destroy();
        }

        return new Response(HTTP.NO_CONTENT);
    });

    server.get(
        '/v1/users/items',
        ({ profileItems }, { queryParams: { socialTypes = [], profileId = '', types = [] } }) => {
            let { models: items } = profileItems.all();

            if (socialTypes?.length) {
                items = items.filter(item => socialTypes.includes(String(item.socialType)));
            }

            if (types?.length) {
                items = items.filter(item => types.includes(item.type));
            }

            if (profileId) {
                items = items.filter(item => profileId === item.profileId);
            }

            return items;
        }
    );
};
